import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DISCOVERY_BLOG_TYPE, DISCOVERY_CLOUD_TYPE } from '@/constants';

type SOURCE_CHANNEL_TYPE = typeof DISCOVERY_CLOUD_TYPE[keyof typeof DISCOVERY_CLOUD_TYPE];

@Component({
  computed: {
    DISCOVERY_CLOUD_TYPE() {
      return DISCOVERY_CLOUD_TYPE;
    },
  },
  methods: {},
  components: {},
})
export default class CollectionChannelTypesCloud extends Vue {
  @Prop({ type: Array }) readonly stats: { count: number; channelType: string | any }[];

  @Emit('change') change(channels: SOURCE_CHANNEL_TYPE) {}

  get totalItems() {
    return this.stats.filter(stat => DISCOVERY_CLOUD_TYPE.ALL.includes(stat.channelType)).reduce((acc, cur) => acc + cur.count, 0);
  }

  countStat(channel: string) {
    return this.stats.find(el => el.channelType === channel)?.count ?? 0;
  }
}
